import request from './request';

// 获取所有标签类型
export function getTagTypes() {
  return request({
    url: '/tag-types',
    method: 'get'
  });
}

// 获取标签类型详情
export function getTagTypeById(id) {
  return request({
    url: `/tag-types/${id}`,
    method: 'get'
  });
}

// 获取标签类型下的标签
export function getTagsByType(tagTypeId) {
  return request({
    url: `/tag-types/${tagTypeId}/tags`,
    method: 'get'
  });
}

// 获取联动标签树
export function getCascadeTags(tagTypeId) {
  return request({
    url: `/tag-types/${tagTypeId}/cascade`,
    method: 'get'
  });
}

